/** UK marketplace working days for delivery ETAs — excludes Sundays (Royal Mail). */

export function startOfDay(dateLike) {
  const d = new Date(dateLike);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function isSunday(dateLike) {
  return new Date(dateLike).getDay() === 0;
}

/** Calendar days (used for buyer confirmation grace periods). */
export function addDays(dateLike, days) {
  const d = new Date(dateLike);
  d.setDate(d.getDate() + Number(days || 0));
  return d;
}

/**
 * Advance by N working days from a date. Sundays are not counted.
 */
export function addWorkingDays(dateLike, days) {
  const d = startOfDay(dateLike);
  if (Number.isNaN(d.getTime())) return d;

  let remaining = Math.max(0, Math.round(Number(days) || 0));
  if (remaining === 0) return d;

  while (remaining > 0) {
    d.setDate(d.getDate() + 1);
    if (!isSunday(d)) {
      remaining -= 1;
    }
  }
  return d;
}
